import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS, Pagination } from '../@config';
import { QuoteEntry, TaskEntry } from '../@models';
import { AppState } from '../@store';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  constructor(private http: HttpClient,
    private store: Store) { }

  CreateOrUpdateTask(payload: TaskEntry): Observable<any> {
    return this.http.post(ENDPOINTS.createOrUpdateTask(), payload);
  }

  createTask(payload: TaskEntry): Observable<any> {
    return this.http.post(ENDPOINTS.createOrUpdateTask(), payload);
  }

  getAll(skipCount: number, searchText?: string): Observable<TaskEntry[]> {
    const userId = this.store.selectSnapshot(AppState.userId);
    return this.http.get<TaskEntry[]>(ENDPOINTS.getTasks(userId, Pagination.maxResultCount, skipCount, searchText || '')).pipe(
      map((respone: any) => respone?.result?.items || []));
  }

  getTenantId(): Observable<any> {
    return this.http.get<any>(ENDPOINTS.getTenantId()).pipe(
      map((respone: any) => respone?.result || []));
  }

  getLogedInUserInfo(): Observable<any> {
    return this.http.get<any>(ENDPOINTS.getLogedInUserInfo()).pipe(
      map((respone: any) => respone?.result?.userInfo || {}));
  }

}
